import moment from "moment";

const ConvertUTCDateToLocalDate = ({ date, label }) => {
  const newDate = moment.utc(date).local().format('MM/DD/YYYY, h:mm A');

  return label + newDate;
};

export default ConvertUTCDateToLocalDate;
